export default __webpack_public_path__ + "static/media/logo.fb1f7ee0.png";